const Checkbox = {
  baseStyle: {
    control: {
      bg: "white",
      border: "none",
      outline: "none",
      _dark: {
        border: undefined,
        outline: undefined,
      },
      _checked: {
        bg: "brand.primary",
        boxShadow: "none",
        borderColor: "brand.primary",
        _dark: {
          bg: "white",
          boxShadow: undefined,
          borderColor: undefined,
        },
      },
    },
  },
};

export default Checkbox;
